import React from 'react';

import { ListSport } from '../../../interfaces/EventsState';

export interface SportContextProps {
  selectedMainMarkets: {
    marketTypeName: string,
    marketTypeCode: number,
    headers: {
      outcomeName: string
    }[],
    collapsed: boolean,
    vars: number
  }[],
  screen: string,
  sport: ListSport
}

const SportContext = React.createContext<Partial<SportContextProps>>({
  selectedMainMarkets: [],
  screen: 'desktop',
  sport: null
});

export default SportContext;
